import React from "react";

export const PhoneHomeIndicator = () => (
  <div data-testid="phone-home-indicator" className="flex justify-center pb-2">
    <div className="h-1 w-32 rounded-full bg-black"></div>
  </div>
);
